import * as React from 'react'
import styled from '@emotion/styled'
import { getAnimation } from './animation'
import { AnimationOptions } from '../../utils/animation'
import { Secondary, Primary } from '@sphinx/components-styles'

interface LoadingBarProps
  extends AnimationOptions,
    React.HTMLAttributes<HTMLDivElement> {
  barColor?: string
  height?: number
  animationKeyframes?: string
}

const Bar = styled.div`
  width: 100%;
  overflow: hidden;
  background-color: ${Primary.neutral.grey5};
`

const Progress = styled.span<Omit<LoadingBarProps, 'backgroundColor'>>`
  width: 0;
  display: block;
  height: ${({ height }) => `${height}px`};
  background: ${({ barColor }) => barColor};

  ${({ barColor, height, animationKeyframes, ...animationOpts }) =>
    getAnimation(animationKeyframes)(animationOpts)};
`

export const LoadingBar: React.FC<LoadingBarProps> = ({
  animationKeyframes,
  height = 5,
  barColor = Secondary.green[100],
  timingFn = 'cubic-bezier(.2, .13, .23, 1)',
  durationMs,
  delayMs,
  iterationCount = 'infinite',
  direction,
  fillMode,
  playState,
  ...rest
}) => (
  <Bar {...rest}>
    <Progress
      animationKeyframes={animationKeyframes}
      timingFn={timingFn}
      iterationCount={iterationCount}
      barColor={barColor}
      height={height}
      delayMs={delayMs}
      durationMs={durationMs}
      direction={direction}
      fillMode={fillMode}
      playState={playState}
    />
  </Bar>
)
